var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenRightArrowIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24Z",
    fill: "#DAFAED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14C18.49 14 14 18.49 14 24C14 29.51 18.49 34 24 34C29.51 34 34 29.51 34 24C34 18.49 29.51 14 24 14ZM26.79 24.53L23.26 28.06C23.11 28.21 22.92 28.28 22.73 28.28C22.54 28.28 22.35 28.21 22.2 28.06C21.91 27.77 21.91 27.29 22.2 27L25.2 24L22.2 21C21.91 20.71 21.91 20.23 22.2 19.94C22.49 19.65 22.97 19.65 23.26 19.94L26.79 23.47C27.09 23.76 27.09 24.24 26.79 24.53Z",
    fill: "#39BD86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRightArrowIc);
export default __webpack_public_path__ + "static/media/green_right_arrow_ic.9bb046a7adaa174918901b848b63fd4c.svg";
export { ForwardRef as ReactComponent };